// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__TL9Uz","inner":"Footer_inner__8Pox2","brand":"Footer_brand__oZWmO","sub":"Footer_sub__fGPix","links":"Footer_links__X9iFI","copy":"Footer_copy__9nCAK"};